import {
	Checkbox,
  Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FiMoreVertical } from 'react-icons/fi';
import { MdArrowDropDown, MdArrowDropUp } from 'react-icons/md';

import { useAuth } from '../../../hooks/auth';

type SortData = {
  por: string;
  cres: boolean;
};
type ControlsData = {
  page: number;
  perPage: number;
  totalPage: number;
};
type FichaData = {
	banca: string;
	cliente: string;
	cod_emp: number;
	cod_ficha: number;
	cod_ped: string;
	cod_pro: number;
	cod_event: number;
	dat_cad: string;
	descricao: string;
	imagem: string;
	nome_pro: string;
	proxima_op: string;
	quant_atual: number;
	quant_incial: number;
	status_des: string;
	usuario: string;
	apontamento: boolean;
}
interface DataTableTableParams {
  fichas: FichaData[];
	setFichas: (fichas: FichaData[]) => void;
	pesqFichas: FichaData[];
	setPesqFichas: (fichas: FichaData[]) => void;
  sort: SortData;
  setSort: (sort: SortData) => void;
  controls: ControlsData;
  handleUpdateList: (page: number, perPage: number, produtos: FichaData[]) => void;
	aponta: FichaData[];
	setAponta: (fichas: FichaData[]) => void;
}

const DataTableTable: React.FC<DataTableTableParams> = ({
  fichas,
	setFichas,
  pesqFichas,
	setPesqFichas,
  sort,
  setSort,
  controls,
  handleUpdateList,
	aponta,
	setAponta,
}) => {
	const { permissions } = useAuth();
	
  function handleSort(prop: string) {
		let mapped: FichaData[] = [];

    const auxCres = !sort.cres;

    if (sort.por === prop) {
      if (auxCres) {
				mapped = pesqFichas.sort((a, b) => {
          return (
            +(Object(a)[prop] > Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      } else {
				mapped = pesqFichas.sort((a, b) => {
          return (
            +(Object(a)[prop] < Object(b)[prop]) ||
            +(Object(a)[prop] === Object(b)[prop]) - 1
          );
        });
      }
      setSort({ ...sort, cres: auxCres });
    } else {
			mapped = pesqFichas.sort((a, b) => {
        return (
          +(Object(a)[prop] > Object(b)[prop]) ||
          +(Object(a)[prop] === Object(b)[prop]) - 1
        );
      });
      setSort({ por: prop, cres: true });
    }

    // setSort({ por: prop, cres: !sort.cres });

    handleUpdateList(1, controls.perPage, mapped);
  };

  return (
		<Table colorScheme="blackAlpha" size='sm'>
      <Thead>
        <Tr>
					<Th cursor="pointer" onClick={() => handleSort('cod_ficha')}>
						<Flex justifyContent="flex-end">
              Ficha
							{sort.por === 'cod_ficha' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
									sort.por === 'cod_ficha' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('dat_cad')}>
						<Flex justifyContent="flex-end">
              Data
              {sort.por === 'dat_cad' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'dat_cad' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('status_des')}>
						<Flex>
              Serviço
              {sort.por === 'status_des' && sort.cres ? (
                <Icon as={MdArrowDropUp} fontSize="20" />
              ) : (
                sort.por === 'status_des' &&
                !sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
              )}
            </Flex>
          </Th>

					<Th cursor="pointer" onClick={() => handleSort('cod_ped')}>
						<Flex justifyContent="flex-end">
							Pedido
							{sort.por === 'cod_ped' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'cod_ped' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('nome_pro')}>
						<Flex>
							Produto
							{sort.por === 'nome_pro' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'nome_pro' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('banca')}>
						<Flex>
							Banca
							{sort.por === 'banca' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'banca' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('descricao')}>
						<Flex>
							Descrição
							{sort.por === 'descricao' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'descricao' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('quant_incial')}>
						<Flex justifyContent="flex-end">
							Qtd. Inicial
							{sort.por === 'quant_incial' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'quant_incial' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('quant_atual')}>
						<Flex justifyContent="flex-end">
							Qtd. Final
							{sort.por === 'quant_atual' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'quant_atual' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					<Th cursor="pointer" onClick={() => handleSort('proxima_op')}>
						<Flex justifyContent="flex-end">
							Operação
							{sort.por === 'proxima_op' && sort.cres ? (
								<Icon as={MdArrowDropUp} fontSize="20" />
							) : (
								sort.por === 'proxima_op' &&
								!sort.cres && <Icon as={MdArrowDropDown} fontSize="20" />
							)}
						</Flex>
					</Th>

					{(permissions.alterar || permissions.excluir) && <Th></Th>}
        </Tr>
      </Thead>

      <Tbody>
        {fichas.map(ficha => {
          return (
						<Tr key={ficha.cod_ficha} fontSize={14} fontWeight={500}>
              <Td isNumeric>
								<Flex>
									<Text color="blue.500" mr={2}>
										{ficha.cod_ficha}
										{ficha.apontamento}
									</Text>
									
									<Checkbox
										isChecked={ficha.apontamento}
										onChange={() => {
											const auxPesqs = pesqFichas;
											const indexPesq = auxPesqs.findIndex(a => a.cod_ficha === ficha.cod_ficha);

											const auxFichas = fichas;
											const indexFichas = auxFichas.findIndex(a => a.cod_ficha === ficha.cod_ficha);

											const auxApontas = aponta;
											const auxFicha = { ...auxFichas[indexFichas], apontamento: !auxFichas[indexFichas].apontamento };

											auxPesqs[indexPesq] = auxFicha;
											auxFichas[indexFichas] = auxFicha;

											setPesqFichas(auxPesqs);
											setFichas(auxFichas);

											if (auxFicha.apontamento) {
												auxApontas.push(auxFicha);
											} else {
												const index = auxApontas.findIndex(a => a.cod_ficha === ficha.cod_ficha);
												auxApontas.splice(index, 1);
											}

											setAponta(auxApontas);
											handleUpdateList(controls.page, controls.perPage, auxPesqs);
										}}
									>
									</Checkbox>
								</Flex>
              </Td>

              <Td isNumeric py="2" color="gray.500">
								{ficha.dat_cad}
              </Td>

							<Td py="2" color="gray.500">
								{ficha.status_des}
              </Td>

							<Td isNumeric py="2" color="gray.500">
								{ficha.cod_ped}
							</Td>

							<Td py="2" color="gray.500">
								{ficha.nome_pro}
							</Td>

							<Td py="2" color="gray.500">
								{ficha.banca}
							</Td>

							<Td py="2" color="gray.500">
								{ficha.descricao}
							</Td>

							<Td isNumeric py="2" color="gray.500">
								{ficha.quant_incial}
							</Td>

							<Td isNumeric py="2" color="gray.500">
								{ficha.quant_atual}
							</Td>

							<Td isNumeric py="2" color="gray.500">
								{ficha.proxima_op}
							</Td>

							{(permissions.alterar || permissions.excluir) && (
								<Td isNumeric>
									<Menu>
										{({ isOpen }) => (
											<>
												<MenuButton
													border={0}
													fontSize="1.5626rem"
													as={IconButton}
													isActive={isOpen}
													aria-label="Options"
													icon={<FiMoreVertical />}
													variant="outline"
													_hover={{
														bg: 'gray.50'
													}}
												/>

												<MenuList p={0} boxShadow='xl'>
													{permissions.alterar && (
														<MenuItem
															fontSize={16}
															fontWeight={500}
															py={3}
															_hover={{ bg: 'gray.50' }}
															onClick={() => { }}
														>
															Editar
														</MenuItem>
													)}

													{permissions.excluir && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled={true}
															>
																Excluir
															</MenuItem>
														</>
													)}

													{permissions.alterar && (
														<>
															<Divider />

															<MenuItem
																fontSize={16}
																fontWeight={500}
																py={3}
																_hover={{ bg: 'gray.50' }}
																isDisabled={true}
															>
																Duplicar
															</MenuItem>
														</>
													)}
												</MenuList>
											</>
										)}
									</Menu>
								</Td>
							)}
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
};

export default DataTableTable;
